import Cookies from 'js-cookie';
import { toCamelCase } from '../utils/helpers';
import { API_BASE_URL } from '../config/api';

const getAuthHeaders = () => {
  const token = Cookies.get('petrofeu_token');
  const headers = { 'Content-Type': 'application/json' };
  if (token) headers['Authorization'] = `Bearer ${token}`;
  return headers;
};

const handleResponse = async (response) => {
  const data = await response.json();
  if (!response.ok) {
    throw new Error(data.message || data.error || 'Request failed');
  }
  return data;
};

export const notificationService = {
  async getNotifications(userId) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/notifications?userId=${userId}`, {
        headers: getAuthHeaders(),
      });
      const data = await handleResponse(response);
      const notifications = data.data?.notifications || data.notifications || [];
      return toCamelCase(notifications);
    } catch (error) {
      console.error('Get notifications error:', error);
      return [];
    }
  },

  async markAsRead(notificationId) {
    const response = await fetch(`${API_BASE_URL}/api/notifications/${notificationId}/read`, {
      method: 'PUT',
      headers: getAuthHeaders(),
    });
    return await handleResponse(response);
  },

  async markAllAsRead(userId) {
    const response = await fetch(`${API_BASE_URL}/api/notifications/read-all`, {
      method: 'PUT',
      headers: getAuthHeaders(),
      body: JSON.stringify({ userId }),
    });
    return await handleResponse(response);
  },

  async deleteNotification(notificationId) {
    const response = await fetch(`${API_BASE_URL}/api/notifications/${notificationId}`, {
      method: 'DELETE',
      headers: getAuthHeaders(),
    });
    return await handleResponse(response);
  },

  async createNotification(notificationData) {
    const response = await fetch(`${API_BASE_URL}/api/notifications`, {
      method: 'POST',
      headers: getAuthHeaders(),
      body: JSON.stringify(notificationData),
    });
    return await handleResponse(response);
  },
};
